import React, { useEffect } from 'react'
import ProductDetailsRelatedProducts from '../Components/ProductDetails/ProductDetailsRelatedProducts';
import ProductDetailsInfo from '../Components/ProductDetails/ProductDetailsInfo';
import ProductDetailsTop from '../Components/ProductDetails/ProductDetailsTop';
import { Link, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const ProductDetails = () => {
    const currentLocation = useLocation();

    const pathSegments = currentLocation.pathname.split('/');
    const product_Name = decodeURIComponent(pathSegments[pathSegments.length - 1])
        .replace(/-/g, ' ')
        .replace(/=/g, ' ');

    useEffect(() => {
        document.title = `Stone Skill | ${product_Name}`;
    }, [product_Name]);


    return (
        <>
            <ToastContainer />
            <main className="main">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link
                                to={"/"}
                                rel="nofollow"
                            >
                                <i className="fi-rs-home mr-5" />
                                Home
                            </Link>
                            <span /> pages <span />{product_Name}
                        </div>
                    </div>
                </div>
                <div className="container mb-30">
                    <div className="row">
                        <div className="col-xl-10 col-lg-12 m-auto">
                            <div className="product-detail accordion-detail">
                                <div className="row mb-50 mt-30">
                                    <ProductDetailsTop />
                                </div>
                                <div className="row mt-60">
                                    <ProductDetailsRelatedProducts />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default ProductDetails